import axios from "axios";

export const getEmailApplyLink = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/emailapplylink/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const editEmailApplyLink = (data) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/emailapplylink/editemailapplylink",
      data
    )
    .then((res) => res.data);
};
